import React, { useCallback, useEffect, useState } from "react";
import { Alert, Card } from "react-bootstrap";
import { FaTrain } from "react-icons/fa";
import { useIntl } from "react-intl";
import { useStore } from "react-redux";
import { useParams } from "react-router-dom";

import { createLocalAxios } from "../../lib/api.js";
import genericTranslations from "../../utils/genericTranslations.js";
import "./VehicleStatusList.scss";

const VehicleStatusList = () => {
  const intl = useIntl();
  const { identifier } = useParams();

  const [vehicleStatuses, setVehicleStatuses] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const store = useStore();

  const fetchVehicleStatuses = useCallback(async () => {
    const localAxios = createLocalAxios(store.getState);

    let response;
    try {
      response = await localAxios.get(
        `vehicle-status/public/byRegion/${identifier}`,
      );
    } catch (err) {
      console.error(`Vehicle statuses: fetching data failed: ${err.message}`);
      setError(err.message);
    } finally {
      setIsLoading(false);
    }

    setVehicleStatuses(response.data);
    setError(null);
  }, [identifier]);

  useEffect(() => {
    fetchVehicleStatuses();

    const intervalId = setInterval(fetchVehicleStatuses, 30000);

    return () => clearInterval(intervalId);
  }, [fetchVehicleStatuses]);

  const dismissError = () => setError(null);

  return (
    <Card>
      <Card.Body>
        {error && (
          <Alert variant="danger" onClose={dismissError} dismissible>
            <Alert.Heading>
              {intl.formatMessage(genericTranslations.errorMessage)}
            </Alert.Heading>
            <p>{error.toString()}</p>
          </Alert>
        )}

        {isLoading && (
          <span className="align-middle">
            {intl.formatMessage(genericTranslations.loadingInProgress)}
          </span>
        )}

        {!isLoading && vehicleStatuses.length === 0 && (
          <span className="align-middle">
            {intl.formatMessage(genericTranslations.nothingFound)}
          </span>
        )}

        {!isLoading && vehicleStatuses.length > 0 && (
          <div className="vehicle-status">
            {vehicleStatuses.map((vehicle) => {
              return (
                <div
                  className="vehicle-status-grid-cell"
                  key={vehicle.vehicleNumber}
                >
                  <div
                    className={`vehicle-status-container vehicle-status-${vehicle.status !== false ? vehicle.status.status.toLowerCase() : "default"}`}
                  >
                    <FaTrain />
                    <h4 className="vehicle-status-number">
                      {vehicle.vehicleNumber}
                    </h4>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default VehicleStatusList;
